import classNames from 'classnames';
import { useCombobox } from 'downshift';
import React, { useEffect, useState } from 'react';
import { FormControl } from 'react-bootstrap';

const Combobox = ({
  disabled,
  entities,
  onInputValueChange,
  onSelectedItemChange,
  isActive,
  getItemName,
  placeholder,
  controlId,
  customMenuItem: CustomMenuItem,
  disabledBlurClearing,
}) => {
  const [inputItems, setInputItems] = useState([...entities]);

  useEffect(() => {
    setInputItems([...entities]);
  }, [entities]);

  const {
    getComboboxProps,
    getInputProps,
    getItemProps,
    getMenuProps,
    getToggleButtonProps,
    isOpen,
  } = useCombobox({
    items: inputItems,
    itemToString: (entity) => (entity ? getItemName(entity) : ''),
    onInputValueChange: ({ inputValue }) => {
      if (inputValue) {
        setInputItems(() => onInputValueChange(inputValue));
      } else {
        setInputItems([...entities]);
      }
    },
    onSelectedItemChange: ({ selectedItem }) =>
      onSelectedItemChange(selectedItem),
    selectedItem: null,
    stateReducer: (state, actionAndChanges) => {
      const { changes, type } = actionAndChanges;
      switch (type) {
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          return {
            ...changes,
            isOpen: true,
            highlightedIndex: state.highlightedIndex,
            inputValue: '',
          };
        case useCombobox.stateChangeTypes.InputBlur:
          return disabledBlurClearing
            ? { ...changes }
            : { ...changes, inputValue: '' };
        default:
          return changes;
      }
    },
  });

  return (
    <div className={classNames('dropdown', { open: isOpen })}>
      <div className="input-group" {...getComboboxProps()}>
        <FormControl
          placeholder={placeholder}
          className="clear"
          {...getInputProps({ disabled, id: controlId, refKey: 'inputRef' })}
        />
        <span className="input-group-btn">
          <div className="btn-group btn-group-info">
            <div
              className="dropdown-toggle btn btn-info btn-clear"
              role="button"
              {...getToggleButtonProps({ disabled })}
            >
              <span className="caret" />
            </div>
          </div>
        </span>
      </div>
      <ul className="dropdown-menu" {...getMenuProps()}>
        {inputItems.map((item, index) => {
          return CustomMenuItem ? (
            <CustomMenuItem
              active={isActive(item)}
              getItemProps={getItemProps}
              item={item}
              index={index}
              key={item.id}
            />
          ) : (
            <ComboboxItem
              active={isActive(item)}
              getItemProps={getItemProps}
              item={item}
              index={index}
              key={item.id}
            >
              {getItemName(item)}
            </ComboboxItem>
          );
        })}
      </ul>
    </div>
  );
};

function ComboboxItem({
  active,
  children,
  getItemProps,
  item,
  index,
  ...props
}) {
  return (
    <li className={classNames({ active })} {...props}>
      <a
        href="#"
        {...getItemProps({
          item,
          index,
          onClick: (event) => event.preventDefault(),
        })}
      >
        {children}
      </a>
    </li>
  );
}

export default Combobox;
